var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "box-typical-form" }, [
    _c("form", { on: { submit: _vm.submit } }, [
      _c(
        "div",
        { staticClass: "form-group" },
        [
          _c(
            "label",
            {
              staticClass: "col-form-label w-100",
              attrs: { for: "status_select" }
            },
            [_vm._v("New Status")]
          ),
          _vm._v(" "),
          _c("custom-radio-component", {
            attrs: { values: _vm.statusOptions },
            model: {
              value: _vm.status,
              callback: function($$v) {
                _vm.status = $$v
              },
              expression: "status"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "form-group" },
        [
          _c(
            "label",
            {
              staticClass: "col-form-label",
              attrs: { for: "comment_textarea" }
            },
            [_vm._v("Comment")]
          ),
          _vm._v(" "),
          _c("textarea", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.comment,
                expression: "comment"
              }
            ],
            staticClass: "form-control textarea mb-2",
            attrs: { id: "comment_textarea" },
            domProps: { value: _vm.comment },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.comment = $event.target.value
              }
            }
          }),
          _vm._v(" "),
          [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col" }, [
                _vm.sendEmail
                  ? _c("label", { staticClass: "col-form-label" }, [
                      _vm._v("Send this status update to customer email")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.sendEmail
                  ? _c(
                      "div",
                      { staticClass: "switch-cont" },
                      [
                        _c("custom-switch-component", {
                          model: {
                            value: _vm.email_sent,
                            callback: function($$v) {
                              _vm.email_sent = $$v
                            },
                            expression: "email_sent"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col" }, [
                _vm.loading
                  ? _c(
                      "button",
                      {
                        staticClass:
                          "btn btn-default btn-rounded btn-sm float-right capitalize mt-2",
                        attrs: { disabed: "" }
                      },
                      [_vm._v("Updating...")]
                    )
                  : _c(
                      "button",
                      {
                        staticClass:
                          "btn btn-primary btn-rounded btn-sm float-right capitalize mt-2",
                        attrs: { type: "submit", disabled: !_vm.status }
                      },
                      [_vm._v("Update Status")]
                    )
              ])
            ])
          ]
        ],
        2
      ),
      _vm._v(" "),
      _vm._m(0)
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-group" }, [
      _c("div", { staticClass: "col-sm-12" })
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6b945c8f", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b945c8f","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./seventytwo/72cms-ui/src/components/helpers/InlineStatusComponent.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-6b945c8f","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./seventytwo/72cms-ui/src/components/helpers/InlineStatusComponent.vue
// module chunks = 0